import locale from "../../../utils/locale";

const yesNoData = [{display: locale('yes'), value: 'Y'}, {display: locale('no'), value: 'N'}];

// const scheduleAppointmentBusinessDaysData = [
//   { display: "8AM - 12AM", value: "8to12" },
//   { display: "1PM - 5PM", value: "1to5" }
// ];

export default [
  {
    name: "needToBeThereForPickup",
    label: locale("needToBeThereForPickup"),
    type: "radio",
    readable: true,
    editable: true,
    required: true,
    dataSource: yesNoData
  }
];



// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/pickupScheduleDetails.js